import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { useCreateSubscriptionMutation } from "@modules/subscriptions/services/mutations";
import { SubscriptionFormValues, subscriptionSchema } from "@modules/subscriptions/validations";
import { isValidCPF } from "@modules/users/utils/isValidCPF";

export function useCreateSubscriptionModal(modalRef: RefObject<ModalRef>, onComplete?: () => void) {
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<SubscriptionFormValues>({
    resolver: zodResolver(subscriptionSchema({
      cpf: {
        validate: async (value) => value ? isValidCPF(value) : true,
        errorMessage: translate("v1/user_admin.errors.invalidCPF"),
      },
    })),
    mode: "onBlur"
  });

  const { mutateAsync, isPending } = useCreateSubscriptionMutation({
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("subscription_admin.success.create"),
      });

      modalRef.current?.close();
      onComplete?.();
    },
  });

  return {
    methods,
    mutateAsync,
    isPending,
  };
}
